<template lang="pug">
.review-page-setup-preview
  preview
    preview-item(:title="$t('feedback_form_preview_title')")
      preview-iphone.mt-4
        div.scrollable
          //- Logo
          .my-8.text-left
            v-card(v-if="resizeImageFileUrl" flat)
              div(align="left")
                v-img(:src="resizeImageFileUrl" contain max-height="64" max-width="64")
                  template(v-slot:placeholder)
                    v-row(class="fill-height ma-0" align="center" justify="center")
                      v-progress-circular(indeterminate color="grey")
            v-avatar(v-else size="64" color="neutral300")
              span.text-md.font-semibold.neutral500--text {{ getInitial(company.name) }}
          //- Questions
          div.my-5(v-for="field in formFields" :key="field.name")
            template(v-if="field.enabled")
              .text-sm.font-medium.neutral500--text.text-left.mb-1 {{ field.name }}
              template(v-if="isTextField(field.type)")
                v-text-field.text-sm.font-normal.round-xl(v-if="isTextField(field.type)" :placeholder="field.placeholder" readonly outlined hide-details dense)
                  template(v-if="field.type === 'date'" #append)
                    v-icon.mt-1(size="17") $yzi-calendar
              template(v-if="field.type === 'phone'")
                phone-input.mt-2(dense readonly placeholder="0123456789")
              template(v-if="field.type === 'long_text'")
                v-textarea.text-sm.font-normal.mt-2.round-xl(outlined dense readonly :placeholder="field.placeholder" hide-details)
              template(v-if="field.type === 'checklist'")
                y-checkbox.my-2(v-for="choice in field.choices" :key="choice" readonly dense)
                  template(#label)
                    .text-sm.font_normal.neutral500--text {{ choice }}
              template(v-if="field.type === 'radiobtn'")
                v-radio-group.my-0(v-model="dummyRadio" hide-details dense)
                  v-radio(v-for="choice in field.choices" :key="choice" readonly color="neutral300")
                    template(#label)
                      .text-sm.font-normal.neutral500--text {{ choice }}
              template(v-if="field.type === 'address'")
                address-field(readonly)
        v-btn.my-2.button-sm(depressed block color="info500" dark) {{ $t('submit_feedback') }}
</template>

<script>
import { mapGetters } from 'vuex'
import Preview from '@/components/review/preview/Preview.vue'
import PreviewItem from '@/components/review/preview/PreviewItem.vue'
import PreviewIphone from '@/components/review/preview/PreviewIphone.vue'
import PhoneInput from '@/components/review/custom/PhoneInput.vue'
import AddressField from '@/components/review/custom/AddressField.vue'

export default {
  name: 'FeedbackFormSetupPreview',
  components: {
    Preview,
    PreviewItem,
    PreviewIphone,
    PhoneInput,
    AddressField
  },
  props: {
    resizeImageFileUrl: {
      type: String,
      default: null
    },
    formFields: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dummyRadio: null
    }
  },
   computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  methods: {
    getInitial (value) {
      let name = value
      let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
      let initials = [...name.matchAll(rgx)] || [];
      initials = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();
      return initials
    },
    isTextField(type) {
      const textFieldDatatypes = ['text', 'number', 'email', 'date']
      return textFieldDatatypes.includes(type)
    }
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.no-padding-x {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.selected-button {
  background: #eeeeee !important;
  border-radius: 16px;
}
::v-deep svg.v-icon.notranslate.v-data-table-header__icon {
  height: 8px !important;
  width: 8px !important;
  margin-left: 8px;
}
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.pre-wrap {
  white-space: pre-wrap;
}
.sticky {
  top: 1vh;
  position: sticky;
}
.scrollable {
  height: 550px;
  overflow-y: auto;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.scrollable::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollable {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
</style>